import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../api';

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/blog?limit=20').then(r => setPosts(r.data.posts)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="spinner" />;

  const featured = posts[0];
  const rest = posts.slice(1);

  return (
    <div>
      {/* Blog Hero */}
      <div style={{ background: 'linear-gradient(135deg, #1e1b4b, #4c1d95)', color: 'white', padding: '60px 24px', textAlign: 'center' }}>
        <div style={{ maxWidth: 700, margin: '0 auto' }}>
          <div style={{ fontSize: 12, fontWeight: 700, letterSpacing: 3, textTransform: 'uppercase', opacity: 0.7, marginBottom: 12 }}>StyleMe Journal</div>
          <h1 style={{ fontSize: 'clamp(32px,6vw,52px)', fontWeight: 900, lineHeight: 1.1, marginBottom: 16, letterSpacing: -1 }}>Fashion, Style &amp; Accessories</h1>
          <p style={{ fontSize: 17, opacity: 0.8, lineHeight: 1.6 }}>Tips, trends and style guides to help you look and feel your best.</p>
        </div>
      </div>

      <div className="container" style={{ maxWidth: 1100, paddingTop: 48 }}>
        {posts.length === 0 ? (
          <div className="empty-state">
            <div className="icon">&#128221;</div>
            <h3>Coming soon</h3>
            <p>We&apos;re crafting some great fashion content. Check back soon!</p>
          </div>
        ) : (
          <>
            {featured && (
              <Link to={`/blog/${featured.slug}`} style={{ textDecoration: 'none', color: 'inherit', display: 'block', marginBottom: 48 }}>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 0, borderRadius: 20, overflow: 'hidden', boxShadow: '0 8px 32px rgba(0,0,0,0.1)', background: 'white' }}
                  onMouseEnter={e => e.currentTarget.style.boxShadow='0 16px 48px rgba(0,0,0,0.15)'}
                  onMouseLeave={e => e.currentTarget.style.boxShadow='0 8px 32px rgba(0,0,0,0.1)'}>
                  <div style={{ background: featured.cover_image ? `url(${featured.cover_image}) center/cover` : 'linear-gradient(135deg,#4f46e5,#7c3aed)', minHeight: 360 }} />
                  <div style={{ padding: '48px 44px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                    <div style={{ fontSize: 11, fontWeight: 800, letterSpacing: 2, color: '#4f46e5', textTransform: 'uppercase', marginBottom: 14 }}>&#11088; Featured Post</div>
                    {featured.tags && <div style={{ marginBottom: 14 }}>{featured.tags.split(',').slice(0,3).map(t => (<span key={t} style={{ fontSize: 11, background: '#f0f0ff', color: '#4f46e5', borderRadius: 100, padding: '3px 10px', marginRight: 6, fontWeight: 600 }}>{t.trim()}</span>))}</div>}
                    <h2 style={{ fontSize: 28, fontWeight: 900, lineHeight: 1.25, marginBottom: 16 }}>{featured.title}</h2>
                    {featured.excerpt && <p style={{ fontSize: 15, color: '#6b7280', lineHeight: 1.7, marginBottom: 20 }}>{featured.excerpt}</p>}
                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, color: '#9ca3af' }}>
                      <span style={{ fontWeight: 600, color: '#374151' }}>{featured.author}</span>
                      <span>{featured.published_at ? new Date(featured.published_at).toLocaleDateString('en-US',{month:'short',day:'numeric',year:'numeric'}) : ''}</span>
                    </div>
                    <div style={{ marginTop: 20 }}><span style={{ fontSize: 14, fontWeight: 700, color: '#4f46e5' }}>Read article &rarr;</span></div>
                  </div>
                </div>
              </Link>
            )}
            {rest.length > 0 && (
              <>
                <h2 style={{ fontSize: 22, fontWeight: 800, marginBottom: 24 }}>More Articles</h2>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(300px,1fr))', gap: 28 }}>
                  {rest.map(post => (
                    <Link key={post.id} to={`/blog/${post.slug}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                      <div style={{ background: 'white', border: '1px solid #e5e7eb', borderRadius: 16, overflow: 'hidden', transition: 'all 0.2s', height: '100%' }}
                        onMouseEnter={e => { e.currentTarget.style.boxShadow='0 8px 24px rgba(0,0,0,0.1)'; e.currentTarget.style.transform='translateY(-2px)'; }}
                        onMouseLeave={e => { e.currentTarget.style.boxShadow='none'; e.currentTarget.style.transform='none'; }}>
                        <div style={{ height: 180, background: post.cover_image ? `url(${post.cover_image}) center/cover` : 'linear-gradient(135deg,#4f46e5,#a855f7)', display:'flex', alignItems:'center', justifyContent:'center', fontSize: 40 }}>
                          {!post.cover_image && '\u2728'}
                        </div>
                        <div style={{ padding: '20px 22px 24px' }}>
                          {post.tags && <div style={{ marginBottom: 10 }}>{post.tags.split(',').slice(0,2).map(t => (<span key={t} style={{ fontSize: 11, background: '#f0f0ff', color: '#4f46e5', borderRadius: 100, padding: '3px 10px', marginRight: 6, fontWeight: 600 }}>{t.trim()}</span>))}</div>}
                          <h3 style={{ fontSize: 18, fontWeight: 800, marginBottom: 10, lineHeight: 1.3 }}>{post.title}</h3>
                          {post.excerpt && <p style={{ fontSize: 14, color: '#6b7280', lineHeight: 1.6, marginBottom: 14 }}>{post.excerpt}</p>}
                          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, color: '#9ca3af' }}>
                            <span>{post.author}</span>
                            <span>{post.published_at ? new Date(post.published_at).toLocaleDateString('en-US',{month:'short',day:'numeric'}) : ''}</span>
                          </div>
                        </div>
                      </div>
                    </Link>
                  ))}
                </div>
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
}
